import apiClient from "./apiClient";

const authServices = {
  login: (payload = {}) => {
    return apiClient.post("/auth/login", payload, {
      options: {
        withoutToken: true, // Skip access_token
      },
    });
  },
  loginAsB12: (payload = {}) => {
    return apiClient.post("/auth/b12-login", payload);
  },
  logout: () => {
    return apiClient.post("/auth/logout");
  },
  editUserProfile: (payload) => {
    return apiClient.post(`/auth/profile`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  resetPassword: (userID) => {
    return apiClient.post(`/auth/reset-password/${userID}`);
  },
  removeImage: (userID) => {
    const url = userID ? `/auth/remove-image/${userID}` : `/auth/remove-image`;
    return apiClient.post(url, { _method: "PUT" });
  },
  me: (payload = {}) => {
    return apiClient.get("/auth/me", payload);
  },
  getNotifications: ({ page = 1, per_page = 10 } = {}) => {
    return apiClient.get(`/notifications?page=${page}&per_page=${per_page}`);
  },
  getNotificationsNotReadCount: () => {
    return apiClient.get(`/notifications-not-read`);
  },
  readNotifications: (id) => {
    return apiClient.get(`/read-notifications/${id}`);
  },
};

export default authServices;
